module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Login ~#loginForm":{"hooks.onStartRendering":[{"value":function () {
if (fox.Navigator.get(0) === 'successful-registration') {
this.setTemplateOptions('successfulRegistration', true);
}
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.SitePage_Login ~#loginForm","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/successfulRegistration.js
// module id = 692
// module chunks = 4